export const integrationSubscriptionStatesEnum = {
    None: "None",
    Active: "Active",
    Ended: "Ended",
} as const;

export const integrationSubscriptionStates = [
    { label: "Оплаченной подписки нет", value: integrationSubscriptionStatesEnum.None },
    { label: "Подписка действует", value: integrationSubscriptionStatesEnum.Active },
    { label: "Срок подписки закончился", value: integrationSubscriptionStatesEnum.Ended },
];
